import { render, staticRenderFns } from "./POSfast.vue?vue&type=template&id=480750e1&scoped=true"
import script from "./POSfast.vue?vue&type=script&lang=js"
export * from "./POSfast.vue?vue&type=script&lang=js"
import style0 from "./POSfast.vue?vue&type=style&index=0&id=480750e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480750e1",
  null
  
)

export default component.exports